"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SET_CLOCK_SKEW_ADJUSTMENT = void 0; // Currently, this action is for testing purposes only.
// Thus, action creator is not needed.

var SET_CLOCK_SKEW_ADJUSTMENT = 'WEB_CHAT/SET_CLOCK_SKEW_ADJUSTMENT';
exports.SET_CLOCK_SKEW_ADJUSTMENT = SET_CLOCK_SKEW_ADJUSTMENT;